module.exports = __webpack_public_path__ + "img/over_65s.ded7c446.jpg";